import { ComponentProps } from 'react'

import { Box, Card, useBreakpoint } from '@factorialco/deprecated-design-system'

interface Props {
  children: ComponentProps<typeof Card>['children']
  onClick?: () => void
}

export const TaskCard = ({ children, onClick }: Props) => {
  const { breakpoint } = useBreakpoint()
  const minWidth = breakpoint === 'xl' || breakpoint === 'l' ? 's360' : 'full'

  return (
    <Box minWidth={minWidth} width={minWidth}>
      <Card onClick={onClick}>{children}</Card>
    </Box>
  )
}
